export type LoadingState<R> = {
  initial: boolean;
  value: R | undefined;
  loading: boolean;
  error: unknown;
};

export const newInitialLoadingState = <R>(): LoadingState<R> => {
  return { initial: true, value: undefined, loading: false, error: undefined };
};

export const newLoadingState = <R>(): LoadingState<R> => {
  return { initial: false, value: undefined, loading: true, error: undefined };
};

export const newLoadedState = <R>(value: R | undefined | null): LoadingState<R> => {
  return { initial: false, value: value === null ? undefined : value, loading: false, error: undefined };
};

export const newErrorState = <R>(error: unknown): LoadingState<R> => {
  return { initial: false, value: undefined, loading: false, error: error || 'unknown error' };
};
